import { Theme } from "./types";

const LightTheme: Theme = {
  title: 'light',

  colors: {
    primary: '#744cb4',
    primary_hover: '#8c62d1',
    red_brand: '#F51010',

    background: '#F5F5F5',
    card_300: '#FFFFFF',
    card: '#FFFFFF',
    text: '#4F4F4F',
    grey_text: '#656565',
    white: '#FFFFFF',

    positive: '#16a34a',
    negative: '#E83A3A',
    warning: '#FA871D',
    neutral: '#1D75FA',

    border_grey: '#CACACA',

    primary_tranparent: 'rgba(124, 192, 255, 0)',
    hover: '#f2eff3',

    dev: "yellow",
  }
}

export { LightTheme };